import { createElement } from 'react';
import { Switch } from '@alifd/next';
import TitleTooltip from '../tooltip-title';
import moment from 'moment';
import ApiSelect from './api-select';
const Cell = ({ value, rowIndex, record, formatType, formatOptions = 'YYYY-MM-DD HH:mm:ss', dict, type, }) => {
    const renderCell = (formatType) => {
        let dictValue = value;
        let uniqueCodeValue = value;
        if (formatType === 'dict') {
            const parentDict = dict?.[0];
            const dictMap = new Map(JSON.parse(localStorage.getItem('dictMap')));
            const targetDict = dictMap?.get(parentDict) || [];
            dictValue = targetDict?.find((item) => item.value === value)?.name;
        }
        else if (formatType === 'uniqueCode') {
            const uniqueCodeMap = new Map(JSON.parse(localStorage.getItem('uniqueCodeMap')));
            const uniqueCode = dict?.[dict?.length - 1];
            const targetUniqueCode = uniqueCodeMap?.get(uniqueCode) || [];
            uniqueCodeValue = targetUniqueCode.find((item) => item.id === value)?.name;
        }
        switch (formatType) {
            case 'text':
                return createElement(TitleTooltip, null, value);
            case 'boolean':
                return createElement(Switch, { autoWidth: true, checked: value, checkedChildren: "\u662F", unCheckedChildren: "\u5426" });
            case 'date':
                return createElement(TitleTooltip, null, value ? moment(value)?.format(formatOptions) : value);
            case 'dict':
                return createElement(TitleTooltip, null, dictValue);
            case 'uniqueCode':
                return createElement(TitleTooltip, null, uniqueCodeValue);
            case 'api':
                return createElement(ApiSelect, { value: value, type: type });
            default:
                return createElement(TitleTooltip, null, value);
        }
    };
    return (createElement("div", { className: "cell-group" },
        createElement("div", { className: "cell" }, renderCell(formatType))));
};
export default Cell;
